import AsyncSelect from 'react-select/async';
import { fetchPostcodeAddressList } from "../../service";
import HeaderTexts from "../../common/HeaderTexts";

const Address = ({ address, setAddress, handleReset, retryJob }) => {

    const renderSearch = () => (
        <AsyncSelect
            isClearable
            cacheOptions
            defaultOptions
            noOptionsMessage={() => 'Insufficient address data for search'}
            loadOptions={fetchPostcodeAddressList}
            onChange={(value) => {
                // handleReset();
                setAddress(value);
            }}
            value={address}   // ✅ bind state here
            isDisabled={retryJob ? true : false}
            styles={{ control: (base) => ({ ...base, width: '100%' }) }}
        />
    );

    return (
        <div className="mx-3">
            <HeaderTexts title="Where should the work be done?"/>
            {renderSearch()}
        </div>
    );
};

export default Address;